
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"8","cy":"8","r":"8","fill":"#EB5757"}}),_c('path',{attrs:{"d":"M9.34 6c.918 0 1.66.716 1.66 1.6C11 9.06 8 11 8 11S5 9.13 5 7.6C5 6.5 5.742 6 6.66 6c.55 0 1.038.261 1.34.661.302-.4.79-.661 1.34-.661z","fill":"#fff"}})])
          )
        }
      }
    